import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '@bvt-atoms';
import './CardEducation.scss';
import { BaseCard } from '@bvt-shared/component/BaseCard';

export default function CardEducation(props) {
  const { data, id,  isLoading, style } = props;

  return (
    <div id={id} style={style}>
      <BaseCard isLoading={isLoading} title='Education' withPadding={true}>
        <ProgressBar data={data} marginBottom='0.35' percentBracket={false} />
      </BaseCard>
    </div>
  );
}

CardEducation.defaultProps = {
  data: [
    {
      color: '#12B2A7',
      type: 'NON SCHOOL',
      percent: 10,
    },
    {
      color: '#49B6C5',
      type: 'ELEMENTARY SCHOOL',
      percent: 20,
    },
    {
      color: '#5CA3E5',
      type: 'JUNIOR HIGHSCHOOL',
      percent: 20,
    },
    {
      color: '#00A8FF',
      type: 'SENIOR HIGHSCHOOL',
      percent: 15,
    },
    {
      color: '#8000FF',
      type: 'DIPLOMA 1,2 & 3',
      percent: 20,
    },
    {
      color: '#9F5EE0',
      type: 'UNIVERSITY',
      percent: 15,
    },
  ],
};

CardEducation.propTypes = {
  data: PropTypes.array,
};
